// Types mirror the documented backend contract so the static UI can be wired
// to the real endpoints later with minimal changes.
//
// GET /api/v1/compro/company-information/step-progress
// GET /api/v1/compro/activities/:tenant_id?limit=10

// Backend only emits 'done' | 'not_started'. 'in_progress' is derived on the
// frontend (the first not_started step that follows a done step) to drive the
// "Sedang Dikerjakan" highlight banner.
export type StepStatus = 'done' | 'in_progress' | 'not_started';

export interface StepProgressItem {
  step_id: number;
  step_key: string;
  step_name: string;
  status: StepStatus;
  count: number;
}

export interface StepProgressData {
  total_steps: number;
  completed_steps: number;
  percentage: number;
  steps: StepProgressItem[];
}

export type ActivityAction = 'created' | 'updated' | 'completed';

export interface ActivityItem {
  id: number;
  tenant_id: number;
  step_key: string;
  step_name: string;
  action: ActivityAction;
  user_id: number | null;
  created_at: string;
}

export const ACTIVITY_ACTION_LABEL: Record<ActivityAction, string> = {
  created: 'ditambahkan',
  updated: 'diperbarui',
  completed: 'telah diselesaikan',
};
